

















import {Component, Prop, Vue} from 'vue-property-decorator';
import {VueComponent} from '../../types';
import CachedImage from '../CachedImage.vue';

@Component({
	components: {CachedImage}
})
export default class ChatMessage extends Vue {
	@Prop({required: true})
	logoComponent!: VueComponent;

	@Prop({required: true})
	avatarImage!: string;

	@Prop({required: true})
	message!: string;

	@Prop({default: 1000})
	typingDelay!: number;

	showTypingIndicator = true;

	created() {
		// -1 for infinite
		if(this.typingDelay !== -1) {
			setTimeout(() => {
				this.showTypingIndicator = false;
			}, this.typingDelay);
		}
	}
}
